export const TEST_ID = 'productCategoryField';

export const DROPDOWN_TEST_ID = 'productCategoryFieldDropdown';

export const NOT_FOUND_INDEX = -1;
